export const initialData = [
    {
        key: 0, seq: 'TCGAATTCCAAGACTAATAGACAGAAACAA',
        range: [5, 30], name: 'sequence 1',
    },
    {
        key: 1, seq: 'GTATTAAGATAAGACACAACAACAAAATTT',
        range: [5, 30], name: 'sequence 2',
    },
    {
        key: 2, seq: 'CAAATACGTCTAACGCATAATTTGATAAAG',
        range: [5, 30], name: 'sequence 3',
    },
    {
        key: 3, seq: 'GTAAACAAATACCCACCTGTCAATAATAGA',
        range: [5, 30], name: 'sequence 4',
    },
    {
        key: 4, seq: 'TGAAAACACATAAGCTCAATTATTTAATAG',
        range: [5, 30], name: 'sequence 5',
    },
    {
        key: 5, seq: 'GTAGGACAAAATACACCCAGTATTAAAAAA',
        range: [5, 30], name: 'sequence 6',
    },
];

// export const initialData = [
//     {
//       'key': 0,
//       'seq': 'TCGTACTTCCCCCCAAGTTAAATACCCGTT',
//     },
//     {
//       'key': 1,
//       'seq': 'CCTGGCTCAATCTAAAGGGTAACTTGCTCT',
//     },
//     {
//       'key': 2,
//       'seq': 'CATCCCGTTAATATAGTCCGTCGATTCCTG',
//     },
//     {
//       'key': 3,
//       'seq': 'ACTCCTAGTGGGCGTCTAGGAGCACTCATC',
//     },
//     {
//       'key': 4,
//       'seq': 'CACCAGTTATGTCAAAGATGCTTCGTCGAT',
//     },
//     {
//       'key': 5,
//       'seq': 'CAAGAGAGTAGGCCTTTTCCACGCACTCTT',
//     },
//     {
//       'key': 6,
//       'seq': 'TGAGACGGCTTCAAAGCTCGCCTTCAAGTT',
//     },
//     {
//       'key': 7,
//       'seq': 'TTCATTAATTTCTGTGATGGTCGCTAATAA',
//     },
//     {
//       'key': 8,
//       'seq': 'CGGCGGATGCTGTTAGCATAATATCAAAAC',
//     },
//     {
//       'key': 9,
//       'seq': 'CAAAGGCGAGGACTACGAAAACCCCTGGTG',
//     },
//     {
//       'key': 10,
//       'seq': 'GTGGACGCTCCGCGCTTTCCTGCCCGGACC',
//     },
//     {
//       'key': 11,
//       'seq': 'ACGTAGTTGACGGACGCTAGCGCTTTAGAG',
//     },
//     {
//       'key': 12,
//       'seq': 'TTACGATGATTATTGCATTCCTCGTCTGAC',
//     },
//     {
//       'key': 13,
//       'seq': 'TAACGAAGTGTAAAGGTCTAAACCGATAAT',
//     },
//     {
//       'key': 14,
//       'seq': 'CACGATACCTGGGGAAGGATTTTTTTCTAA',
//     },
//   ];
